import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showGlimpseAlert: false,
  showSngAlert: false,
  showStipaAlert: false,
  showSyncAlert: false,
};

const alertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    closeGlimpseAlert: (state, _action) => {
      state.showGlimpseAlert = false;
    },
    openGlimpseAlert: (state, _action) => {
      state.showGlimpseAlert = true;
    },
    closeSngAlert: (state, _action) => {
      state.showSngAlert = false;
    },
    openSngAlert: (state, _action) => {
      state.showSngAlert = true;
    },
    closeStipaAlert: (state, _action) => {
      state.showStipaAlert = false;
    },
    openStipaAlert: (state, _action) => {
      state.showStipaAlert = true;
    },
    closeSyncAlert: (state, _action) => {
      state.showSyncAlert = false;
    },
    openSyncAlert: (state, _action) => {
      state.showSyncAlert = true;
    },
  },
});

export const {
  closeGlimpseAlert,
  openGlimpseAlert,
  closeSngAlert,
  openSngAlert,
  closeStipaAlert,
  openStipaAlert,
  closeSyncAlert,
  openSyncAlert,
} = alertSlice.actions;

export default alertSlice.reducer;
